import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-xml';
import 'ace-builds/src-noconflict/theme-monokai';

interface QuestionCodeEditorProps {
  code: string;
  tempQuestionData?: any;
  onValueChange: (value: string) => void;
}

const QuestionCodeEditor = ({
  code,
  onValueChange,
}: QuestionCodeEditorProps) => {
  const [codeSegment, setCodeSegment] = useState('');
  const aceEditorRef = React.useRef<AceEditor>(null);

  useEffect(() => {
    setCodeSegment(code);
  }, [code]);


  const handleOnChange = (value: string, _event?: any) => {
    onValueChange(value);
    setCodeSegment(value);
  };

  return (
    <Box>
      <Box
        sx={{
          height: '50vh',
          overflow: 'auto',
          '&::-webkit-scrollbar': {
            display: 'block',
          },
        }}
      >
        <AceEditor
          ref={aceEditorRef}
          mode="xml"
          theme="monokai"
          name="QUESTION_CODE_EDITOR"
          onChange={handleOnChange}
          fontSize={14}
          lineHeight={20}
          editorProps={{ $blockScrolling: true }}
          highlightActiveLine={true}
          value={codeSegment}
          setOptions={{
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            enableSnippets: true,
            showLineNumbers: true,
            useWorker: false,
            tabSize: 2,
          }}
          minLines={15}
          maxLines={300}
          style={{ width: '100%', minHeight: '100px' }}
        />
      </Box>
    </Box>
  );
};

export default QuestionCodeEditor;
